import React from 'react';
import cn from 'classnames';

import Badge from 'components/generic/Badge.component';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import createNodeKey from 'utils/react/createNodeKey.util';
import C from 'utils/values/constant.util';

import CN from './Pricing.module.scss';

const DATA_TABLE_LEFT = C([
  { feature: 'Google Reviews', subText: '', setupFee: '20', monthlyFee: '10' },
  { feature: 'Social Media', subText: '', setupFee: '20', monthlyFee: '10' },
  {
    feature: 'Digital Bundle ',
    subText: '(Google reviews & Instagram feed integration)',
    setupFee: '35',
    monthlyFee: '15',
  },
]);

const DATA_TABLE_RIGHT = C([
  { feature: 'Offers', setupFee: '49', monthlyFee: '10' },
  { feature: 'Vouchers', setupFee: '49', monthlyFee: '5' },
  { feature: 'Shop (via Shopify)', setupFee: '99', monthlyFee: '10' },
  { feature: '2nd Business', setupFee: '99', monthlyFee: '5' },
  { feature: 'Blog', setupFee: '199', monthlyFee: '20' },
]);

const tableLeftClass = cn({
  [CN.tableContainer]: true,
  [CN.tableLeft]: true,
});

const tableRightClass = cn({
  [CN.tableContainer]: true,
  [CN.tableRight]: true,
});

const Pricing = ({ tag }) => (
  <div data-tag={fromAnyToTrimmed(tag)}>
    <div className={CN.component}>
      <div className={tableLeftClass}>
        <div className={CN.badgeContainer}>
          <Badge name="Add-on Features Available" variant="fine" />
        </div>
        <table className={CN.table}>
          <thead>
            <tr>
              <th>Features</th>
              <th>Add-on fee</th>
            </tr>
          </thead>
          <tbody>
            {DATA_TABLE_LEFT.map((row, index) => (
              <tr key={createNodeKey({ index })}>
                <td>
                  {row.feature} {row.subText && <small className={CN.subStr}>{row.subText}</small>}
                </td>
                <td className={CN.bold}>
                  {row.monthlyFee}/<span className={CN.small}>month</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className={tableRightClass}>
        <div className={CN.badgeContainer}>
          <Badge name="Additional Custom Pages" variant="raspberry" />
        </div>
        <table className={CN.table}>
          <thead>
            <tr>
              <th>Pages</th>
              <th>Add-on fee</th>
            </tr>
          </thead>
          <tbody>
            {DATA_TABLE_RIGHT.map((row, index) => (
              <tr key={createNodeKey({ index })}>
                <td>{row.feature}</td>

                <td className={CN.bold}>
                  {row.monthlyFee}/<span className={CN.small}>month</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

export default Pricing;
